<template>
  <v-app-bar color="white" height="180px" flat tile>
    <v-container class="py-4">
      <div class="d-flex flex-column">
        <div
          class="d-flex align-center"
          :class="[
            informations.address || social.length
              ? 'justify-space-between'
              : 'justify-center ',
          ]"
        >
          <router-link to="/">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="d-block"
              height="58px"
            />
          </router-link>

          <div>
            <div class="d-flex align-center pl-4">
              <v-sheet max-width="360px">
                <v-btn
                  class="text-body-2 text-none btn-contact"
                  color="#767676"
                  :href="informations.google_maps"
                  target="_blank"
                  min-height="36px"
                  height="auto"
                  depressed
                  text
                >
                  <v-icon color="primary" size="20" left>
                    fa-map-marker-alt
                  </v-icon>
                  {{ informations.address }}
                </v-btn>
              </v-sheet>

              <template v-for="({ text, link, icon }, keySocial) in social">
                <v-btn
                  :key="keySocial"
                  color="transparent"
                  :href="link"
                  target="_blank"
                  min-width="auto"
                  :title="text"
                  depressed
                  rounded
                  small
                  fab
                >
                  <v-icon color="primary" size="20">{{ icon }}</v-icon>
                </v-btn>
              </template>
            </div>

            <v-sheet
              color="rgba(0, 0, 0, 0.1)"
              width="100%"
              height="1px"
            ></v-sheet>
          </div>
        </div>

        <div class="d-flex justify-space-between align-center mt-6">
          <div class="d-flex">
            <template v-for="({ text, to, dropdown }, keyMenu) in menu">
              <v-btn
                v-if="!dropdown"
                :key="keyMenu"
                class="
                  text-caption text-lg-body-1 text-none
                  font-weight-regular
                  px-2 px-lg-3
                  py-5
                  nav-link
                "
                :to="to"
                active-class="nav-link-active"
                tile
                depressed
                text
              >
                <span class="font-secondary">
                  {{ text }}
                </span>
              </v-btn>

              <v-menu v-else :key="keyMenu" offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      text-caption text-lg-body-1 text-none
                      font-weight-regular
                      px-2 px-lg-3
                      py-5
                      nav-link
                    "
                    active-class="nav-link-active"
                    tile
                    depressed
                    text
                  >
                    <span class="font-secondary">
                      {{ text }}
                    </span>

                    <v-icon class="ml-3" size="10"> fa-chevron-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    :to="item.to"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </div>

          <ButtonWidget
            v-if="informations.whatsapp"
            color="primary"
            text-color="white"
            :href="getWhatsappLinkFromPhone(informations.whatsapp)"
            target="_blank"
          >
            WhatsApp
          </ButtonWidget>
        </div>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import ButtonWidget from "../../widgets/ButtonWidget.vue";
import { menu } from "../../../config";
import { getSocial } from "../../../utils/getSocial";
import { getWhatsappLinkFromPhone } from "../../../utils/getWhatsappLinkFromPhone";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
  components: {
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  color: #24353e;

  &:focus:before,
  &:hover:before,
  &:before {
    opacity: 0;
  }

  &:focus,
  &:hover {
    color: var(--v-primary-base);

    i {
      color: var(--v-primary-base);
    }
  }
}

.btn-contact::v-deep {
  .v-btn__content {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
